<script>
import { mapActions } from "pinia";

export default {
  name: 'LongCollapsableText',
  data() {
    return {
      collapsed: true,
      fullText: '',
    };
  },
  props: {
    newsId: {
      type: Number,
    },
    text: {
      type: String,
    },
  },
  methods: {
    ...mapActions('newsFeed', ['getNewsTextData']),
    collapse() {
      this.collapsed = true;
    },
    expand() {
      if (this.fullText) {
        this.collapsed = false;
      } else {
        this.getNewsTextData(this.newsId)
          .then((res) => {
            this.fullText = res.data;
            this.collapsed = false;
          });
      }
    },
  },
  computed: {
    isLong() {
      return this.text.length === 255 && this.text.endsWith('...');
    },
  },
};
</script>

<template>
  <div
    v-if="text"
    class="news-long-text">
    <div v-if="isLong">
      <div
        v-if="collapsed"
        class="text-content">
        {{ text }}
        <span
          class="news-long-text-show-more"
          @click="expand"
        >Show more</span>
      </div>
      <div
        v-if="!collapsed"
        class="text-content">
        {{ fullText }}
        <span
          class="news-long-text-show-more"
          @click="collapse"
        >Show less</span>
      </div>
    </div>
    <div
      v-else
      class="text-content">
      {{text}}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.news-long-text {
  text-align: left;

  .text-content {
    font-size: 12px;
    font-weight: normal;
    color: #4f4f4f;
    line-height: 1.42;
    letter-spacing: -0.01px;
    overflow-wrap: break-word;

    .news-long-text-show-more {
      font-size: 12px;
      color: #a163cd;
      font-weight: 600;
      line-height: 1.2;
    }
  }
}

</style>
